import { z } from 'zod'

/** 寄送邀請信紀錄 Schema */
export const invitationRecordSchema = z.object({
  /** 邀請紀錄主表 ID */
  id: z.string(),
  /** 寄送者 */
  sender: z.string(),
  /** 寄送者姓名[英文] */
  englishName: z.string(),
  /** 寄送者姓名 */
  name: z.string(),
  /** 寄送時間 */
  sendTime: z.string(),
  /** 筆數 */
  count: z.number()
})

/** 寄送邀請信紀錄 */
export interface InvitationRecord
  extends z.infer<typeof invitationRecordSchema> {}
